"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var UILock =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UILock, _React$Component);

  function UILock() {
    (0, _classCallCheck2.default)(this, UILock);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILock).apply(this, arguments));
  }

  (0, _createClass2.default)(UILock, [{
    key: "componentDidMount",
    // UILock should replace instances of the lock icon when used to indicate that there is a feature limit
    // After mounting it checks its context for a function set by the LockedFeature component, and calls it if it exists
    // The parent then knows that it has a lock in its descendants
    value: function componentDidMount() {
      var sendLockVerification = this.context.sendLockVerification;

      if (sendLockVerification) {
        sendLockVerification();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var propsToPass = (0, _extends2.default)({}, this.props, {
        name: 'locked'
      });
      return _react.default.createElement(_UIIcon.default, propsToPass);
    }
  }]);
  return UILock;
}(_react.default.Component);

UILock.propTypes = {
  color: _react.PropTypes.string
};
UILock.contextTypes = {
  sendLockVerification: _react.PropTypes.func
};
var _default = UILock;
exports.default = _default;
module.exports = exports.default;